import { render, staticRenderFns } from "./canvasVideo.vue?vue&type=template&id=7fefb0aa&"
import script from "./canvasVideo.vue?vue&type=script&lang=js&"
export * from "./canvasVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports